// Module
var code = "<div class=\"page-settings-unit\"> <div class=\"title-buttons\"> <ap-button id=\"add-unit\" type=\"add\"></ap-button> </div> <div class=\"content-settings\"> <ap-aggrid id=\"grid\"></ap-aggrid> </div> </div>";
// Exports
export default code;